module.exports = __webpack_public_path__ + "static/media/louis3.9f67c763.mp3";